import { db } from 'technical/db';

export type BackendDrawConfig = {
  label: string;
};

export const drawConfigSyncService = {
  async download(drawConfigs: BackendDrawConfig[]): Promise<void> {
    await db.segmentDrawConfigs.bulkPut(drawConfigs);
  },
};
